import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import Features from '../../components/Features/Features';
// import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
// import CampaignSection from '../../components/CampaignSection/CampaignSection';
// import Testimonial from '../../components/Testimonial/Testimonial';
// import FunFact from '../../components/FunFact/FunFact';
// import TeamSection from '../../components/TeamSection/TeamSection';
// import BlogSection from '../../components/BlogSection/BlogSection';
// import InstagramSection from '../../components/InstagramSection/InstagramSection';
// import Donors from '../../components/Donors/Donors';
import Footer from '../../components/footer/Footer';
// import PartnerSection from '../../components/PartnerSection/PartnerSection';
// import Scrollbar from '../../components/scrollbar/scrollbar';
// import abimg from '../../images/about.jpg'
// import Logo from '../../images/logo.svg'
import Logo from '../../images/NewWFCOLogo2.svg'
import HeroSlider from '../../components/heroslider/heroslider';

import { hpServiceSection } from '../../data/data';
import { homepgHeroData } from "../../data/data";
import { homepgNavbarData } from '../../data/data';
import { homepgFeaturesData } from '../../data/data';
import { homepgFooterData } from '../../data/data';
import { slides } from '../../data/data';

const HomePage =() => {
    return(
        <Fragment>
            <Navbar hclass={'wpo-site-header-s1'} topbarNone={'topbar-none'} Logo={Logo} data={homepgNavbarData}/>
            {/* <Hero data={homepgHeroData}/> */}
            <HeroSlider slides={slides}/>
            <Features data={homepgFeaturesData}/>
            {/* <About abimg={abimg}/> */}
            <ServiceSection data={hpServiceSection}/>
            {/* <CampaignSection/> */}
            {/* <Testimonial/> */}
            {/* <FunFact/> */}
            {/* <TeamSection/>   */} {/* For now this is removed, but this could be a really helpful section as we continue down the line and build our team */}
            {/* <Donors/>
            <BlogSection/>
            <InstagramSection/>
            <PartnerSection/> */}
            <Footer logo={Logo} data={homepgFooterData}/>
            {/* <Scrollbar/> */}
        </Fragment>
    )
};
export default HomePage;